<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g5p1Im/tc-custom/9781526766014.jpg?1704483141793" alt="This image is the cover for the book Pioneers of Irregular Warfare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pioneers of Irregular Warfare
      </h1>
      <p class="bookDescription body article font2">
        <p>Covert operations and ingenious weapons for irregular warfare were developed rapidly, and with great success, by the British during the Second World War, and the story of the most famous organizations involved like SOE, the SAS and Section D of SIS is now well known, but Military Intelligence (Research), the smallest but one of the most influential of these units is relatively unknown.  Malcolm Atkin’s intriguing and meticulously researched account describes their role at the heart of the War Office in trying to develop a ‘respectable’ arm of irregular warfare and their innovations ranging from the early Commandos, sticky bombs, limpet mines, booby traps, and even helicopters to the creation of the MI9 escape organization. They were an ‘ideas factory’ rather than an operational body but the book describes their worldwide operations including Finland, Norway, Romania, the Middle East and Central Africa.  This is also a story of conflicting personalities between Jo Holland, the visionary but self-effacing head of MI(R) and his ambitious deputy, Colin Gubbins (later head of SOE), and the latter’s private war with SIS.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Atkin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98fc3b08